export default __webpack_public_path__ + "static/media/IconLock.d58f79a7.svg";